// Copyright (c) 2020 Deere & Company

import actions from '../../actions-list';

export const updateFacetFilterText = text => ({
    text,
    type: actions.UPDATE_TABM_FACET_FILTER_TEXT
});



// WEBPACK FOOTER //
// ./src/tabm/wip/action-creators/facet-filter-text.js